import {
	Component, OnInit, HostListener, ElementRef, ViewChild,
} from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { environment } from '../../environments/environment';
import { Meta, Title } from '@angular/platform-browser';
declare var $: any;

// Services
import { PageService } from '../providers/page/page.service';
import { LazyLoaderService } from '../services/lazy-loader.service';
// import { SpinalThreeService } from '../providers/SplineThree/spinal-three.service';
declare const google: any;
@Component({
	selector: 'app-home',
	templateUrl: './home.component.html',
	styleUrls: ['./home.component.scss'],
})
export class HomeComponent implements OnInit {
	@ViewChild('myVideo') videoElement!: ElementRef;
	@ViewChild('canvas', { static: true })
	containerRef!: ElementRef<HTMLDivElement>;
	baseUrl: any;
	focus;
	imagepath: any;
	spline: any;
	sectionWidth: number = 10; // Initial height
	intervalId: any;
	isChangingRandom = false;
	@HostListener('window:scroll', ['$event'])
	onScroll(event: Event): void {
		const scrollTop = window.scrollY || document.documentElement.scrollTop;

		// Adjust height and font size based on scroll position
		this.sectionWidth = Math.min(100, 50 + scrollTop / 10); // Max height: 100px
		if (this.spline) {
			this.spline.setZoom(1, 1);
		}
	}
	clientImgarray: any = [];
	filteredClients: any = [];
	constructor(
		private pageservice: PageService,
		private metaTagService: Meta,
		private lazyLoader: LazyLoaderService,
		// private splineThreeService: SpinalThreeService,
		private titleService: Title) {
		this.imagepath = environment.backendUrl + '/public/';
		this.baseUrl = environment.baseUrl + '/assets';
		this.get_PageMeta();
		this.clientImgarray.push(
			{ id: 1, img: this.baseUrl + '/img/home/logos/dnour.svg', class: '', alt: 'D’nour Logo | Branding, UI/UX, SEO & eCommerce | Web Development Dubai' },
			{ id: 2, img: this.baseUrl + '/img/home/logos/crystal.svg', class: '', alt: 'Logo | Best Web Development Services in Dubai' },
			{ id: 3, img: this.baseUrl + '/img/home/logos/miniaar.svg', class: '', alt: 'Miniaar Logo | Branding and Web Design services  |  eCommerce in Dubai' },
			{ id: 4, img: this.baseUrl + '/img/home/logos/bni.svg', class: '', alt: 'BNI | Branding and Web Design services' },
			{ id: 5, img: this.baseUrl + '/img/home/logos/angle.svg', alt: 'Logo | Custom Branding services Dubai' },
			{ id: 6, img: this.baseUrl + '/img/home/logos/pakhis.svg', class: '', alt: 'Pakhi’s Logo Branding & UI/UX | Luxury Brand Identity & Web Design services' },
			{ id: 7, img: this.baseUrl + '/img/home/logos/drminnie.svg', class: '', alt: 'drminnie Logo | Branding Services in Dubai | website development Services in Dubai' },
			{ id: 8, img: this.baseUrl + '/img/home/logos/veddentta.svg', class: '', alt: 'Logo | Web Development and Design Services Dubai | Branding Solutions' },
			{
				id: 9,
				img: this.baseUrl + '/img/home/logos/autokoorosh.svg',
				class: '', alt: 'Logo | Branding Services in Dubai | website development Services in Dubai',
			},
			{ id: 10, img: this.baseUrl + '/img/home/logos/fractal.svg', class: '', alt: 'FractalMetrics Logo | Data-Driven Branding & Digital Solutions' },
			{
				id: 11,
				img: this.baseUrl + '/img/home/logos/corporate.svg',
				class: '', alt: 'corporate | Branding Services in Dubai',
			},
			{ id: 12, img: this.baseUrl + '/img/home/logos/aetrio.svg', class: '', alt: 'Logo | Branding Services | Web Design Services Dubai' },
			{ id: 13, img: this.baseUrl + '/img/home/logos/wrae.svg', class: '', alt: 'wrae Logo | Branding Services in Dubai | website development Services in Dubai' },
			{ id: 14, img: this.baseUrl + '/img/home/logos/beyou.svg', class: '', alt: 'Logo | Branding, Web Design, SEO & eCommerce Development Dubai' },
			{
				id: 15,
				img: this.baseUrl + '/img/home/logos/alchemative.svg',
				class: '', alt: 'alchemative | Branding Services in Dubai',
			},
			{ id: 16, img: this.baseUrl + '/img/home/logos/Asset 13.svg', class: '', alt: 'tahadeer Logo | Branding Services in Dubai' },
			{
				id: 17,
				img: this.baseUrl + '/img/home/logos/caratcraft.svg',
				class: '', alt: 'caratcraft | Branding Services in Dubai ',
			},
			{ id: 18, img: this.baseUrl + '/img/home/logos/ep.svg', class: '', alt: 'Epic Travel Logo | Custom Web Design and Branding Services Dubai' },
			{
				id: 19,
				img: this.baseUrl + '/img/home/logos/holidaymate.svg',
				class: '', alt: 'Logo | Branding & Web Development Services for Travel industry',
			},
			{ id: 20, img: this.baseUrl + '/img/home/logos/j.avenue.svg', class: '', alt: 'J Avenue Logo | Best Branding Agency for Luxury Brands in Dubai' },
			// { id: 21, img: this.baseUrl + "/img/home/logos/jwarashri.svg", class:'' },
			{
				id: 22,
				img: this.baseUrl + '/img/home/logos/maney-angel.svg',
				class: '', alt: 'maney-angel | UX/UI Design | Best Website design services Dubai',
			},
			{
				id: 23,
				img: this.baseUrl + '/img/home/logos/santosh-kotli.svg',
				class: '', alt: 'santosh-kotli | UX/UI Design | Best Website design services Dubai',
			},
			{
				id: 24,
				img: this.baseUrl + '/img/home/logos/solitaire-events.svg',
				class: '', alt: 'Solitair Logo | UX/UI Design | Best Website design services Dubai',
			},
			{ id: 25, img: this.baseUrl + '/img/home/logos/spacex.svg', class: '', alt: 'Logo | Web development services | Branding & Web Design Agency Dubai' },
			{
				id: 26,
				img: this.baseUrl + '/img/home/logos/urban-excellence.svg',
				class: '', alt: 'Logo | Custom Website Development services in Dubai | Branding Solutions',
			},
			{
				id: 27,
				img: this.baseUrl + '/img/home/logos/virtual-key.svg',
				class: '', alt: 'virtual-key | Branding Services in Dubai ',
			},
			{ id: 28, img: this.baseUrl + '/img/home/logos/zlk.svg', class: '', alt: 'zlk' }
		);
		this.filteredClients = this.clientImgarray.slice(0, 15);
	}

	onHover() {
		if (!this.isChangingRandom) {
			this.isChangingRandom = true;
			this.intervalId = setInterval(() => {
				this.filterClients();
			}, 2000);
		}
	}

	filterClients() {
		this.filteredClients.forEach((cl) => {
			cl.class = '';
		});
		let notvisibleClients = this.clientImgarray;
		let randomClients = [];
		for (var i = 0; i < 2; i++) {
			var idx = Math.floor(Math.random() * notvisibleClients.length);
			let tempRandom = randomClients.filter((cl) => cl.id == idx);
			if (tempRandom.length == 0) {
				randomClients.push(notvisibleClients[idx]);
			}
		}
		for (var j = 0; j < randomClients.length; j++) {
			let tempRandom = this.filteredClients.filter(
				(cl) => cl.id == randomClients[j].id
			);
			if (tempRandom.length == 0) {
				var idy = Math.floor(Math.random() * this.filteredClients.length);
				this.filteredClients[idy] = randomClients[j];
				this.filteredClients[idy].class = 'blur';
			}
		}
	}

	ngOnInit() {
		

		// const canvas = document.getElementById('canvas') as HTMLCanvasElement;
		// this.spline = new Application(canvas);
		// this.spline.load(
		// 	'https://prod.spline.design/0zfpbAp9XmUp3SaF/scene.splinecode'
		// );
		// if (this.containerRef && this.containerRef.nativeElement) {
		// 	const container = this.containerRef.nativeElement;
		// 	this.splineThreeService.initialize(
		// 		container,
		// 		'https://prod.spline.design/0zfpbAp9XmUp3SaF/scene.splinecode'
		// 	);
		// }

		window.scroll({
			top: 0,
			left: 0,
			behavior: 'smooth',
		});
		let input_group_focus = document.getElementsByClassName('form-control');
		let input_group = document.getElementsByClassName('input-group');
		for (let i = 0; i < input_group.length; i++) {
			input_group[i].children[0].addEventListener('focus', function () {
				input_group[i].classList.add('input-group-focus');
			});
			input_group[i].children[0].addEventListener('blur', function () {
				input_group[i].classList.remove('input-group-focus');
			});
		}
		$('li').removeClass('main-menu__item--active');
		$('#home').addClass('main-menu__item--active');
		
		this.onHover();
	}

	get_PageMeta() {
		let obj = { pageName: 'home' };
		this.pageservice.getpageWithName(obj).subscribe((response) => {
			if (response.body.code == 200) {
				this.titleService.setTitle(response?.body.result.meta_title);
				this.metaTagService.updateTag({
					name: 'description',
					content: response?.body.result.meta_description,
				});
				this.metaTagService.updateTag({
					name: 'keywords',
					content: response?.body.result.meta_keywords,
				});
				this.metaTagService.updateTag({
					rel: 'canonical',
					href: 'https://www.pixtar.ae/home',
				});
			} else if (response.code == 400) {
			} else {
			}
		});
	}

	ngAfterViewInit() {
		const elem = this.videoElement.nativeElement;
		elem.muted = true; // Ensure the video is muted for autoplay compatibility
		elem.loop = true;

		// Attempt to autoplay the video when the component initializes
		elem.play().catch((err) => {
			console.log('Autoplay failed, user interaction may be required:', err);
		});

		this.lazyLoader.loadScript('https://unpkg.com/@splinetool/viewer/build/spline-viewer.js')
      .then(() => console.log('Spline viewer loaded'))
      .catch(() => console.error('Failed to load spline viewer script'));
	}

	playInFullscreenWithAudio() {
		const elem = this.videoElement.nativeElement;

		// Unmute the video
		elem.muted = false;
		elem.loop = true;

		// Remove controls to avoid interference in fullscreen mode
		elem.removeAttribute('controls');

		// Attempt to play the video and request fullscreen
		elem
			.play()
			.then(() => {
				if (elem.requestFullscreen) {
					elem.requestFullscreen();
				} else if (elem.webkitRequestFullscreen) {
					// Safari
					elem.webkitRequestFullscreen();
				} else if (elem.msRequestFullscreen) {
					// IE11
					elem.msRequestFullscreen();
				} else if (elem.mozRequestFullScreen) {
					// Firefox
					elem.mozRequestFullScreen();
				}
			})
			.catch((err) => {
				console.log('Error entering fullscreen with audio: ', err);
			});
	}

	@HostListener('document:fullscreenchange', ['$event'])
	onFullscreenChange() {
		const elem = this.videoElement.nativeElement;

		if (
			document.fullscreenElement === elem ||
			(document as any).webkitFullscreenElement === elem ||
			(document as any).msFullscreenElement === elem ||
			(document as any).mozFullScreenElement === elem
		) {
			// Video is in fullscreen, attempt to play
			elem.play().catch((err) => {
				console.log('Could not play in fullscreen mode:', err);
			});
		} else {
			// Video exited fullscreen, restore controls and mute the video
			elem.setAttribute('controls', '');
			elem.muted = true;
		}
	}
}
